var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 16.001c-.01-8.274 6.717-15 15-15v.002c8.283 0 15.014 6.716 15 15a15.047 15.047 0 0 1-.762 4.737h-4.49V8.12L16 17.868l-9.75-9.75v12.62H1.762A15.042 15.042 0 0 1 1 16zm8.5-.145 4.256 4.255 2.241 2.242 2.242-2.242 4.254-4.255v7.94h6.324c-2.633 4.32-7.392 7.21-12.82 7.21-5.428 0-10.187-2.889-12.82-7.208H9.5v-7.942z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmr);
export default __webpack_public_path__ + "static/media/XMR.82d6ce8ce635d42492f028aaa1e3e1c3.svg";
export { ForwardRef as ReactComponent };